import type { CSSProperties } from 'react';
import { statusColor } from '@/lib/color';
import type { OperationalStatus } from '@/types';

interface StatusDotProps {
  status: OperationalStatus;
  size?: number;
  pulsing?: boolean;
  label?: string;
}

export function StatusDot({ status, size = 8, pulsing, label }: StatusDotProps) {
  const color = statusColor(status);
  const style: CSSProperties = {
    display: 'inline-block',
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    flexShrink: 0,
  };
  if (pulsing) {
    return (
      <span
        style={{
          position: 'relative',
          display: 'inline-block',
          width: size,
          height: size,
        }}
      >
        <span style={style} aria-label={label} />
        <span
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background: color,
            opacity: 0.5,
            animation: 'iris-pulse 2s ease-out infinite',
          }}
        />
      </span>
    );
  }
  return <span style={style} aria-label={label} />;
}
